export default "__VITE_ASSET__b9014ae8__"